/**
 * Stale times per data class. Finance data is never cached as fresh.
 * See CLAUDE.md "TanStack Query rules".
 */
export const STALE = {
  session: 5 * 60_000,
  reference: 10 * 60_000,
  list: 30_000,
  record: 15_000,
  queue: 0,
  finance: 0,
  notifications: 0,
} as const;

export const POLL = {
  queue: 30_000,
  notifications: 60_000,
  job: 1_500,
} as const;

export const FINANCE_QUERY = {
  staleTime: STALE.finance,
  gcTime: 2 * 60_000,
  refetchOnMount: 'always' as const,
};
